<template>
    <div
        class="search-inner-1"
        @mouseenter="mouseEnterction"
        @mouseleave="mouseLeavection"
    >
        <div class="search-top">
            <div class="search-left">
                <img
                    class="logo"
                    src="@/assets/svg/home/logo.svg"
                    @click="goHome"
                    alt="商城Logo"
                />
            </div>
            <div class="searchinpbox">
                <el-autocomplete
                    v-model="searchinner"
                    :placeholder="searchplaceholderInner"
                    :fetch-suggestions="querySearch"
                    @blur="handleBlur"
                    @focus="handleFocus"
                    @select="handleSelect"
                    class="searchinput"
                    :class="keyWords.length > 0 ? 'searchinput-active' : ''"
                    oninput="value=if(value.length>64)value=value.slice(0,64)"
                    :debounce="0"
                    select-when-unmatched="true"
                    popper-class="searchinput-el"
                    ref="searchinnerInp"
                >
                    <template #prefix>
                        <div
                            class="searchSelect"
                            style="display: none"
                            ref="TypeInnerRef"
                            @click.stop="searchTypeAction"
                            :class="
                                showSearchTypeFlag === true
                                    ? 'searchSelect-active'
                                    : ''
                            "
                        >
                            <p class="searchSelect-p">
                                {{ searchType }}
                            </p>
                            <img
                                src="@/assets/svg/home/select-down.svg"
                                @click.stop="searchTypeAction"
                                alt="下拉按钮"
                            />
                            <b class="searchSelect-solid"></b>
                            <div
                                class="searchSelect-down"
                                v-show="showSearchTypeFlag"
                            >
                                <div class="searchSelect-down-box">
                                    <p
                                        class="searchSelect-down-item"
                                        :class="
                                            searchType === '传感器'
                                                ? 'is-active'
                                                : ''
                                        "
                                        @click.stop="
                                            changeSelectTypeAction('传感器')
                                        "
                                    >
                                        传感器
                                    </p>
                                    <p
                                        class="searchSelect-down-item"
                                        :class="
                                            searchType === '方案'
                                                ? 'is-active'
                                                : ''
                                        "
                                        @click.stop="
                                            changeSelectTypeAction('方案')
                                        "
                                    >
                                        方案
                                    </p>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #suffix>
                        <p class="search-icon-inp" @click="onSearch(searchinner)">搜索</p>
                    </template>
                </el-autocomplete>
                <div
                    class="input-inner display-flex"
                    v-if="
                        searchinner === '' &&
                        hotShowFlag === true &&
                        searchType === '传感器'
                    "
                >
                    <!-- <p
                          class="searchplaceholder"
                          @click="clicksearchplaceholder"
                      >
                          {{ searchplaceholder }}
                      </p> -->
                    <div class="hot-goods display-flex">
                        <p
                            class="font-size-mini hot-goods-p"
                            v-for="item in newRecommendData"
                            :key="item.id"
                            @click="recommendChoose(item.productName, item.id)"
                        >
                            {{ item.productName }}
                        </p>
                    </div>
                </div>
                <ul
                    class="autoInp-inner"
                    v-if="keyWords.length > 0 && searchType === '传感器'"
                >
                    <li
                        class="keywords-li"
                        v-for="item in keyWords"
                        :key="item.id"
                    >
                        <p
                            @click="keywordChoose(item.keyword, item.id)"
                            class="keywords-p"
                            v-html="item.title"
                        ></p>
                    </li>
                </ul>
                <div
                    class="history"
                    :style="{ display: searchActive ? 'flex' : 'none' }"
                    v-if="!showSearchTypeFlag"
                >
                    <div class="history-left">
                        <div class="history-title display-flex">
                            <p>搜索历史</p>
                            <i @click="clearStorage">全部清除</i>
                        </div>
                        <div
                            class="font-tips fetch display-flex"
                            v-for="(item, index) in fetchSearchData"
                            :key="item"
                            @click="onSearchHistory(item.keyword, item.type)"
                        >
                            <p class="no-wrap-once">
                                <!-- <span>{{ item.type }}</span> -->
                                <span>{{ item.keyword }}</span>
                            </p>
                            <el-icon @click.stop="deleteStorage(index)">
                                <Close />
                            </el-icon>
                        </div>
                        <div v-if="fetchSearchData?.length <= 0" style="margin-top: 100px; text-align: center; font-size: 13px; color: #828282;">暂无搜索记录</div>
                    </div>
                    <div class="history-right">
                        <div class="history-title">
                            <p class="font-size-mini">热销榜</p>
                        </div>
                        <div class="hot">
                            <div
                                class="hot-item"
                                v-for="item in storeShop.hotData"
                                :key="item.id"
                                @click="goDetails(item.id)"
                            >
                                <img
                                    :src="item.spuDefaultImg"
                                    :alt="item.productName"
                                />
                                <div class="hot-item-right">
                                    <p class="name">
                                        {{ item.productName }}
                                    </p>
                                    <p
                                        class="price"
                                        v-if="
                                            item.priceMin &&
                                            item.isPriceConfirm === 1
                                        "
                                    >
                                        ¥ {{ Number(item.priceMin) }}
                                    </p>
                                    <!-- <p class="price" v-else>-</p> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="search-right display-flex"
                style="margin-left: 10px;"
            >
                <div class="search-right-box" @click="goShop" style="width: 106px;">
                    <img src="@/assets/svg/home/shop-d9581c92.svg" alt="购物车" />
                    <p>
                        购物车<span class="search-right-box-span">{{
                            storeShop.haveGoods > 99
                                ? '99+'
                                : storeShop.haveGoods
                        }}</span>
                    </p>
                </div>
                <div class="search-right-box mine-message" @click="goMessage" style="width: 94px;">
                    <img src="@/assets/svg/home/message.svg" alt="消息" />
                    <p>消息<span class="search-right-box-span">{{
                            store.messageNum > 99
                                ? '99+'
                                : store.messageNum
                        }}</span>
                    </p>
                </div>
                <div
                    style="width: 122px; justify-content: center;"
                    class="search-bottom-box display-flex"
                    v-if="userInfo.username"
                    @click.stop="goMineInformation"
                    :class="{
                        'search-bottom-box-active': showmineFlag,
                        'new-msg': store.messageNum > 0,
                    }"
                >
                    <img
                        src="@/assets/svg/home/mine-f6a2f2cd.svg"
                        style="margin-right: 3px"
                        alt="用户"
                    />
                    <p class="no-wrap-once">
                        {{ userInfo.username }}
                    </p>
                    <div class="show-search-user">
                        <div class="mine-inner" ref="MineInnerRef">
                            <p @click.stop="goOrder">
                                <img
                                    src="@/assets/images/ProHome/mine-order.png"
                                    alt="我的订单"
                                />
                                <i>我的订单</i>
                            </p>
                            <p @click.stop="goOutLogin">
                                <img
                                    src="@/assets/images/ProHome/mine-outlogin.png"
                                    alt="退出"
                                />
                                <i>退出</i>
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    class="search-bottom-box display-flex"
                    style="width: 122px; justify-content: center;"
                    v-else
                >
                    <img src="@/assets/svg/home/mine-f6a2f2cd.svg" alt="登陆" />
                    <p @click="goLogin">登录/注册</p>
                </div>
            </div>
        </div>
        <div class="search-bottom navlink">
            <div class="search-bottom-box">
                <a class="search-bottom-text" @click="goHome">首页</a>
                <a
                    :href="mainDomainUrl + '/search.html'"
                    class="search-bottom-text"
                    >商城</a
                >
                <a
                    :href="mainDomainUrl + '/tech.html'"
                    class="search-bottom-text"
                    >技术资讯</a
                >
                <a
                    :href="mainDomainUrl + '/download.html'"
                    class="search-bottom-text"
                    >技术下载</a
                >
                <a
                    class="search-bottom-text customizedService"
                    :class="{'on' : route.name === 'module'}"
                    @click="goServiceIndex"
                    >定制服务</a
                >
                <a
                    class="search-bottom-text technicalService"
                    :class="{'on' : route.name === 'technology'}"
                    @click="goTechnology"
                    >技术服务</a
                >
                <a class="search-bottom-text supplier" :class="{'on' : route.name === 'settled'}" @click="goSettled"
                    >供应商合作</a
                >
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import {
    reactive,
    toRefs,
    defineComponent,
    computed,
    onBeforeMount,
    onMounted,
    nextTick,
    ref,
    watch,
} from 'vue';
import { useUserStore } from '@/store/User';
import { useShopStore } from '@/store/Shop';
import { useRouter, useRoute } from 'vue-router';
import { geTel } from '@/utils/filter';
import loginApi from '@/api/PcModule/login';
import VueCookies from 'vue-cookies';
import {
    getTipsProduce,
    getTipsProduceClick,
    putRecommendClick,
    getNewRecommend,
} from '@/api/PcModule/home';
import { Delete, Close } from '@element-plus/icons-vue';
import { onClickOutside } from '@vueuse/core';
import { openUrl } from '@/utils/common';
export default defineComponent({
    name: 'SearchLogo',
    components: {
        Delete,
        Close,
    },
    props: {
        // 可控制是否显示推荐
        showTips: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        const store = useUserStore();
        const storeShop = useShopStore();
        let route = useRoute();
        const data = reactive({
            userInfo: {},
            shopData: [],
            fetchSearchData: [], //历史记录存在localStorage
            searchinner: '', // 搜索内容
            keyWords: [], //智能提示列表
            searchActive: false, //是否显示搜索历史列表
            showmineFlag: false, //是否打开遮罩层
            hotShowFlag: true,
            newRecommendData: [],
            searchType: '传感器',
            showSearchTypeFlag: false,
            searchplaceholderInner: '',
            isShow: true,
            once: false,
            mainDomainUrl: import.meta.env.VITE_SEO_HOST,
        });
        const refData = toRefs(data);
        const SearchInp = ref();
        const router = useRouter();
        const goLogin = () => {
            router.push({
                name: 'login',
                query: { callback: location.protocol + '//' + location.host +  location.pathname + (location.search !== ''  ? '?' + encodeURI(location.search.substring(1)) : '') }
            });
        };
        const goHome = () => {
            if (route.name !== 'proHome') {
                refData.searchinner.value = '';
                location.replace(refData.mainDomainUrl.value);
            }
        };
        watch(
            () => store.userInfo.id,
            (newPath, oldPath) => {
                if (store.userInfo.id) {
                    refData.userInfo.value = store.userInfo || {};
                }
            },
            { immediate: true },
        );
        watch(
            () => route.name,
            (newPath, oldPath) => {
                if (newPath === 'proHome') {
                    refData.isShow.value = true;
                    refData.once.value = false;
                } else {
                    refData.once.value = false;
                }
            },
            { immediate: true },
        );
        onBeforeMount(() => {
            refData.userInfo.value = store.userInfo || {};
            if (route.query.type === '方案') {
                refData.searchType.value = '方案';
            } else {
                refData.searchType.value = '传感器';
            }
            if (route.query.key) {
                refData.searchinner.value = route.query.key;
            }
            if (route.name !== 'shop' && store.userInfo.id) {
                storeShop.getShopAction();
            }
            if (refData.searchType.value === '传感器') {
                storeShop.getSearchProduceAction().then(() => {
                    refData.searchplaceholderInner.value =
                        storeShop.searchplaceholder;
                });
            } else {
                refData.searchplaceholderInner.value = '';
            }

            if (storeShop.hotData.length === 0) {
                storeShop.getRecommendAction();
            }

            refData.fetchSearchData.value = [];
            store.fetchSearchData.map((item) => {
                if (refData.searchType.value === item.type) {
                    refData.fetchSearchData.value.push(item);
                }
            });
            NewRecommend();
        });
        const NewRecommend = async () => {
            let data = await getNewRecommend();
            if (data.code == 200) {
                refData.newRecommendData.value = data.data || [];
            }
        };
        // 去购物车
        const goShop = () => {
            if (store.userInfo.id) {
                router.push({
                    name: 'shop',
                });
            } else {
                router.push({
                    name: 'login',
                    query: { callback: location.protocol + '//' + location.host +  location.pathname + (location.search !== ''  ? '?' + encodeURI(location.search.substring(1)) : '') }
                });
            }
        };
        const hotData = computed(() => {
            return storeShop.hotData;
        });
        const searchplaceholder = computed(() => {
            return storeShop.searchplaceholder;
        });
        // 选择热推商品
        const recommendChoose = (keyword: string, id: string) => {
            refData.searchType.value = '传感器';
            onSearch(keyword);
            putRecommendClickAction(id);
        };
        // 选择热推商品
        const onSearchHistory = (keyword: string, type: string) => {
            refData.searchType.value = type;
            onSearch(keyword);
        };
        const putRecommendClickAction = async (id: string) => {
            let data = await putRecommendClick({
                recommendId: id,
            });
        };
        const fetchDataFilter = (keyword: string) => {
            let arr = [...store.fetchSearchData];
            let newArr = [];
            if (keyword !== '') {
                refData.fetchSearchData.value = [];
                arr.map((item) => {
                    if (item.type === refData.searchType.value) {
                        if (item.keyword !== keyword) {
                            newArr.push(item);
                        }
                    } else {
                        newArr.push(item);
                    }
                });
                newArr.unshift({
                    keyword,
                    type: refData.searchType.value,
                });
                let contentArr = [];
                let goodsArr = [];
                newArr.map((item) => {
                    if (item.type === '传感器') {
                        goodsArr.push(item);
                    } else {
                        contentArr.push(item);
                    }
                    if (item.type === refData.searchType.value) {
                        refData.fetchSearchData.value.push(item);
                    }
                });
                refData.fetchSearchData.value.length > 6
                    ? (refData.fetchSearchData.value =
                          refData.fetchSearchData.value.slice(0, 6))
                    : [];
                contentArr.length > 6
                    ? (contentArr = contentArr.slice(0, 6))
                    : [];
                goodsArr.length > 6 ? (goodsArr = goodsArr.slice(0, 6)) : [];

                store.fetchSearchData = [...goodsArr, ...contentArr];
            }
        };
        const goOutLogin = async () => {
            let data = await loginApi.outLogin({
                token: store.userInfo.access_token,
            });
            if (data.code === 200) {
                refData.showmineFlag.value = false;
                let old = store.userInfo.username;
                let fetchSearchData = store.fetchSearchData;
                localStorage.removeItem('user');
                localStorage.removeItem('shop');
                localStorage.removeItem('main');
                localStorage.removeItem('userInfo');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('expires_in');
                localStorage.removeItem('temporaryuserInfo');
                store.old = old;
                store.userInfo = {};
                store.lastPath = {};
                storeShop.haveGoods = 0;
                store.fetchSearchData = fetchSearchData;
                const noLoginArr = [
                    'NotFound',
                    'sitemap',
                    'login',
                    'register',
                    'forget',
                    'wxLogin',
                ];
                VueCookies.remove('token', null);
                setTimeout(() => {
                    location.replace(import.meta.env.VITE_SEO_HOST);
                }, 0);
                // }
            }
        };
        const handleSelect = (value) => {
            if (value.value === '') {
                if (refData.searchType.value === '传感器') {
                    onSearch(searchplaceholder.value);
                } else {
                    onSearch('');
                }
                refData.searchActive.value = false;
            } else {
                onSearch(refData.searchinner.value);
            }
        };
        // 智能搜索提示
        const getTipsProduceAction = async () => {
            let data = await getTipsProduce({
                pageSize: 10,
                currentPage: 1,
                keyword: refData.searchinner.value,
            });
            if (data.code === 200) {
                if (data.data.keywords) {
                    data.data.keywords.map((item) => {
                        let replaceReg = new RegExp(
                            '(' + refData.searchinner.value + ')',
                            'ig',
                        );
                        item.title = item.keyword.replace(
                            replaceReg,
                            `<span style="color:#0071DC;font-size: 14px;">$1</span>`,
                        );
                    });
                }
                return data.data.keywords;
            }
        };
        const querySearch = (queryString: string, cb) => {
            if (refData.searchType.value === '传感器') {
                if (refData.searchinner.value) {
                    if (refData.searchinner.value.length > 100) {
                        refData.searchinner.value =
                            refData.searchinner.value.slice(0, 100);
                    }
                    refData.searchActive.value = false;
                    getTipsProduceAction().then((data) => {
                        if (data instanceof Array) {
                            // cb(data);
                            data.length >= 12
                                ? (refData.keyWords.value = data.slice(0, 12))
                                : (refData.keyWords.value = data || []);
                        } else {
                            refData.keyWords.value = [];
                            // cb([]);
                        }
                    });
                } else {
                    refData.searchActive.value = true;
                    refData.keyWords.value = [];
                    cb([]);
                }
            } else {
                if (refData.searchinner.value) {
                    refData.searchActive.value = false;
                } else {
                    refData.searchActive.value = true;
                }
                refData.keyWords.value = [];
                cb([]);
            }
        };
        // 智能搜素
        const keywordChoose = (keyword: string, id: string) => {
            onSearch(keyword);
            getTipsProduceClickAction(id);
        };
        // 搜索次数
        const getTipsProduceClickAction = async (id: string) => {
            let data = await getTipsProduceClick({
                id,
            });
        };
        const trimAll = (ele) => {
            return ele.replace(
                /[`~!@#$%^&*+=|{}':;'\[\]<>?~！@#￥%……&*——+|{}【】‘；：”“’。，、？]/g,
                '',
            );
        };
        // 整理搜索逻辑
        const onSearch = (keyword: string) => {
            keyword = trimAll(keyword);
            if (keyword === '' && refData.searchType.value === '传感器') {
                keyword = searchplaceholder.value;
            }
            if (refData.searchType.value === '传感器') {
                keyword = keyword.trim();
                keyword.length > 64 ? (keyword = keyword.slice(0, 64)) : '';
                // 赋值
                refData.searchinner.value = keyword;
                // 存当前值
                storeShop.keywordNow = keyword;
                // 存放浏览器历史记录
                fetchDataFilter(keyword);
                // 关闭下拉
                refData.keyWords.value = [];
                refData.showSearchTypeFlag.value = false;
                location.href =
                    refData.mainDomainUrl.value +
                    `/search.html?type=综合&key=${storeShop.keywordNow}`;
            } else {
                if (keyword !== '') {
                    keyword = keyword.trim();
                    keyword.length > 64 ? (keyword = keyword.slice(0, 64)) : '';
                    // 赋值
                    refData.searchinner.value = keyword;
                    // 存当前值
                    storeShop.keywordNow = keyword;
                    // 存放浏览器历史记录
                    fetchDataFilter(keyword);
                }
                // 关闭下拉
                refData.keyWords.value = [];
                refData.showSearchTypeFlag.value = false;
                location.href =
                    refData.mainDomainUrl.value +
                    `/searchContent.html?type=0&key=${keyword}`;
            }
        };
        const searchinnerInp = ref();
        // 点击搜索提示
        const clicksearchplaceholder = () => {
            searchinnerInp.value.focus();
        };
        // 没有搜索条件时显示历史记录和推荐内容
        const handleBlur = (value) => {
            refData.hotShowFlag.value = true;
            setTimeout(() => {
                // refData.searchActive.value = false;
                refData.keyWords.value = [];
            }, 300);
        };
        const handleFocus = () => {
            if (refData.searchinner.value === '') {
                refData.fetchSearchData.value = [];
                store.fetchSearchData.map((item) => {
                    if (refData.searchType.value === item.type) {
                        refData.fetchSearchData.value.push(item);
                    }
                });
                setTimeout(() => {
                    refData.searchActive.value = true;
                }, 200);
            } else {
                setTimeout(() => {
                    refData.searchActive.value = false;
                }, 200);
            }
        };

        //  清除历史记录
        const clearStorage = () => {
            refData.fetchSearchData.value = [];
            store.fetchSearchData = store.fetchSearchData.filter(function (
                item,
            ) {
                return refData.searchType.value !== item.type;
            });
        };
        const deleteStorage = (index) => {
            refData.fetchSearchData.value.splice(index, 1);
            if (refData.searchType.value === '传感器') {
                store.fetchSearchData.map((item) => {
                    if (refData.searchType.value === '传感器') {
                        store.fetchSearchData.splice(index, 1);
                    }
                });
            } else if (refData.searchType.value === '方案') {
                store.fetchSearchData.map((item) => {
                    if (refData.searchType.value === '方案') {
                        store.fetchSearchData.splice(index, 1);
                    }
                });
            }
        };
        // 点击不是展开列表的位置的元素
        const MineInnerRef = ref(null);
        onClickOutside(MineInnerRef, () => {
            refData.showmineFlag.value = false;
        });
        // 我的信息
        const goMineInformation = () => {
            refData.showmineFlag.value = false;
            if (store.userInfo.id) {
                router.push({
                    name: 'mineInformation',
                });
            } else {
                router.push({
                    name: 'login',
                    query: { callback: location.protocol + '//' + location.host +  location.pathname + (location.search !== ''  ? '?' + encodeURI(location.search.substring(1)) : '') }
                });
            }
        };
        // 我的订单
        const goOrder = () => {
            refData.showmineFlag.value = false;
            if (store.userInfo.id) {
                router.push({
                    name: 'mineOrder',
                });
            } else {
                router.push({
                    name: 'login',
                    query: { callback: location.protocol + '//' + location.host +  location.pathname + (location.search !== ''  ? '?' + encodeURI(location.search.substring(1)) : '') }
                });
            }
        };
        // 系统消息
        const goMessage = () => {
            refData.showmineFlag.value = false;
            if (store.userInfo.id) {
                router.push({
                    name: 'mineMessage',
                });
            } else {
                router.push({
                    name: 'login',
                    query: { callback: location.protocol + '//' + location.host +  location.pathname + (location.search !== ''  ? '?' + encodeURI(location.search.substring(1)) : '') }
                });
            }
        };
        const goSettled = () => {
            router.push({
                name: 'settled',
            });
        };
        const goTechnicalservice = () => {
            router.push({
                name: 'Modellist',
            });
        };

        const goGoodslist = () => {
            router.push({
                name: 'Goodslist',
            });
        };

        // 商品详情
        const goDetails = (id) => {
            if (id) {
                window.open(
                    import.meta.env.VITE_SEO_HOST + '/details/' + id + '.html',
                );
                refData.searchActive.value = false;
            }
        };
        const goCustomization = () => {
            router.push({
                name: 'customization',
            });
        };
        const goModelIndex = () => {
            router.push({
                name: 'modelIndex',
            });
        };
        const goTechnology = () => {
            router.push({
                name: 'technology',
            });
        };

        const goServiceIndex = () => {
            router.push({
                name: 'module',
            });
        };
        const searchTypeAction = () => {
            if (refData.showSearchTypeFlag.value) {
                refData.showSearchTypeFlag.value = false;
            } else {
                refData.showSearchTypeFlag.value = true;
            }
        };
        const changeSelectTypeAction = (searchType) => {
            refData.searchType.value = searchType;
            refData.searchinner.value = '';
            refData.showSearchTypeFlag.value = false;
            if (refData.searchType.value === '传感器') {
                refData.searchplaceholderInner.value =
                    storeShop.searchplaceholder;
                refData.fetchSearchData.value = [];
                store.fetchSearchData.map((item) => {
                    if (item.type === '传感器') {
                        refData.fetchSearchData.value.push(item);
                    }
                });
            } else {
                refData.searchplaceholderInner.value = '';
                refData.fetchSearchData.value = [];
                store.fetchSearchData.map((item) => {
                    if (item.type === '方案') {
                        refData.fetchSearchData.value.push(item);
                    }
                });
            }
        };
        const TypeInnerRef = ref(null);
        onClickOutside(TypeInnerRef, () => {
            refData.showSearchTypeFlag.value = false;
        });
        const scrollTop = ref(0);
        window.addEventListener('scroll', () => {
            scrollTop.value =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            if (route.name !== 'proHome') {
                handleScroll();
                refData.once.value = true;
            } else {
                refData.once.value = false;
            }
        });
        let timer = null;
        const isScrolling = ref(false);
        const handleScroll = () => {
            if (scrollTop.value === 0) {
                refData.isShow.value = true;
            } else {
                refData.isShow.value = false;
            }
        };
        const mouseEnterction = () => {
            if (route.name !== 'proHome') {
                refData.isShow.value = true;
            }
        };
        const mouseLeavection = () => {
            if (route.name !== 'proHome') {
                if (scrollTop.value === 0) {
                    refData.isShow.value = true;
                } else {
                    refData.isShow.value = false;
                }
            }
        };
        onMounted(() => {
            document.body.onclick = function (e: any) {
                if (
                    e.target.className != 'el-input__inner' &&
                    !document.querySelector('.history').contains(e.target)
                ) {
                    refData.searchActive.value = false;
                }
            };
        });
        return {
            ...refData,
            hotData,
            store,
            storeShop,
            goHome,
            goLogin,
            goShop,
            querySearch,
            geTel,
            recommendChoose,
            goOutLogin,
            SearchInp,
            goServiceIndex,
            onSearch,
            handleBlur,
            handleFocus,
            clearStorage,
            deleteStorage,
            MineInnerRef,
            keywordChoose,
            handleSelect,
            goMineInformation,
            goOrder,
            goMessage,
            goTechnology,
            searchplaceholder,
            searchinnerInp,
            clicksearchplaceholder,
            goSettled,
            goGoodslist,
            goDetails,
            goCustomization,
            searchTypeAction,
            changeSelectTypeAction,
            TypeInnerRef,
            onSearchHistory,
            goTechnicalservice,
            goModelIndex,
            scrollTop,
            route,
            mouseEnterction,
            mouseLeavection,
        };
    },
});
</script>
<style scoped lang="scss">
.search-inner-1 {
    background: #fff;
    width: 100%;
    height: 124px;
    min-width: $inner-width;
    position: fixed;
    top: 0;
    z-index: 99;
    .search-top {
        width: 1200px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        background: #fff;
        box-sizing: border-box;
        align-items: center;
        .search-left {
            width: 206px;
            margin-right: 20px;
            flex-shrink: 0;
            .logo {
                width: 206px;
                height: 40px;
                cursor: pointer;
            }
        }
        .search-bottom-box {
            color: #0071DC;
            height: 40px;
            text-decoration: none;
            font-size: 14px;
            text-align: center;
            display: flex;
            border-radius: 8px;
            margin-left: 10px;
            position: relative;
            cursor: pointer;
            padding: 10px;
            background: #E5F1FC;
            box-sizing: border-box;
            border: 1px solid transparent;
            align-items: center;
            &.new-msg {
                position: relative;
                &::after {
                    content: '';
                    display: block;
                    width: 5px;
                    height: 5px;
                    background-color: #ffc220;
                    border-radius: 50px;
                    position: absolute;
                    right: 0;
                    top: 9px;
                    display: none;
                }
                &:hover .show-search-user {
                    display: block;
                }
            }
            img {
                width: 20px;
                height: 20px;
                margin-right: 6px;
            }
            p {
                font-size: 14px;
                line-height: 140%;
                color: #0071DC;
                padding-top: 2px;
            }
        }
        .search-bottom-box:hover {
            border-color: #0071DC;
        }
        .search-right {
            flex-shrink: 0;
            position: relative;
        }
        .search-right-box {
            color: #0071DC;
            height: 40px;
            text-decoration: none;
            font-size: 14px;
            text-align: center;
            display: flex;
            border-radius: 8px;
            margin-left: 10px;
            position: relative;
            cursor: pointer;
            padding: 10px;
            background: #E5F1FC;
            box-sizing: border-box;
            border: 1px solid transparent;
            align-items: center;
            img {
                width: 20px;
                height: 20px;
                margin-right: 4px;
            }
            p {
                color: #0071DC;
                position: relative;
                font-family: 思源黑体 CN;
                font-size: 14px;
                font-style: normal;
                line-height: normal;
                .search-right-box-span {
                    position: absolute;
                    right: -25px;
                    top: -7px;
                    background: #ffc220;
                    color: #333;
                    justify-content: center;
                    font-size: 12px;
                    line-height: 16px;
                    border-radius: 8px;
                    width: 28px;
                    height: 16px;
                    text-align: center;
                }
            }
            &.mine-message {
                .search-right-box-span {
                    right: -27px;
                }
            }
        }
        .search-right-box:hover {
            border-color: #0071DC;
            // border-radius: 20px;
        }
    }
    .show-search-user {
        position: absolute;
        top: 38px;
        right: 0;
        z-index: 98;
        display: none;
        padding-top: 10px;
        .mine-inner {
            width: 156px;
            height: 104px;
            background: #ffffff;
            box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
            border-radius: 0px 0px 4px 4px;
            padding: 8px 6px;
            box-sizing: border-box;
            p {
                padding-left: 16px;
                height: 44px;
                line-height: 44px;
                box-sizing: border-box;
                cursor: pointer;
                align-items: center;
                display: flex;
                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 8px;
                }
                i {
                    font-size: 14px;
                    line-height: 140%;
                    color: #333333;
                    b {
                        font-size: 14px;
                        line-height: 140%;
                        color: $font-color;
                    }
                }
            }
            p:hover {
                background: #f1f9ff;
            }
        }
    }
    .divider {
        color: #fff;
        height: 0;
        margin-top: 0;
        margin-bottom: 0;
    }
    .search-bottom {
        width: 100%;
        height: 44px;
        box-sizing: border-box;
        background: #B2D4F5;
        display: flex;
        align-items: center;
        .search-bottom-box {
            display: flex;
            margin: 0 auto;
            width: 1200px;
            .search-bottom-text {
                color: #333;
                cursor: pointer;
                font-family: 思源黑体 CN;
                font-size: 16px;
                font-style: normal;
                line-height: normal;
                margin-right: 10px;
                position: relative;
                padding: 8px 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                height: 36px;
                box-sizing: border-box;
                &.on,
                &:hover {
                    background: #0071DC;
                    color: #fff;
                }
                .new {
                    position: absolute;
                    color: #000;
                    font-size: 10px;
                    font-weight: 500;
                    border-radius: 4px 7px 7px 1px;
                    background: #ffc220;
                    padding: 1px 3px;
                    top: -7px;
                    right: -30px;
                }
            }
        }
    }
}
.searchinpbox {
    position: relative;
    display: inline-block;
    width: 612px;
    flex-shrink: 0;
    .autoInp-inner {
        position: absolute;
        width: 612px;
        background: #fff;
        top: 50px;
        z-index: 5;
        overflow: hidden;
        border-radius: 0 0 6px 6px;
        box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.2);
        .keywords-li {
            padding-left: 14px;
            padding-right: 16px;
            line-height: 38px;
            height: 38px;
            cursor: pointer;
            .keywords-p {
                font-size: 14px;
                color: $font-color-weight-txt;
            }
        }
        .keywords-li:hover {
            background: #f1f9ff;
        }
    }
    .history {
        position: absolute;
        width: 847px;
        min-width: 847px;
        background: #fff;
        top: 50px;
        display: flex;
        z-index: 5;
        border-radius: 6px;
        box-shadow: 4px 4px 30px 0px rgba(72, 84, 106, 0.08);
        padding: 20px 10px 20px 10px;
        box-sizing: border-box;
        .history-left {
            position: relative;
            width: 257px;
            min-width: 257px;
            box-sizing: border-box;
            .history-title {
                justify-content: space-between;
                margin-bottom: 13px;
                padding-right: 20px;
                padding-left: 10px;
                p {
                    font-size: 14px;
                    font-weight: 700;
                    color: $font-color-weight-txt;
                }
                i {
                    cursor: pointer;
                    font-size: 12px;
                    font-weight: 400;
                    color: #828282;
                }
            }
            .font-tips {
                justify-content: space-between;
            }
            .fetch {
                margin-right: 10px;
                padding: 0 10px;
                line-height: 38px;
                height: 30px;
                cursor: pointer;
                box-sizing: border-box;
                margin-bottom: 4px;
                p {
                    font-size: 14px;
                    line-height: 140%;
                    color: $font-color-weight-txt;
                }
                .el-icon {
                    display: none;
                    color: $font-color-weight-txt;
                    cursor: pointer;
                    font-size: 14px;
                    line-height: 14px;
                }
            }
            .fetch:nth-last-of-type() {
                margin-bottom: 0;
            }
            .fetch:hover {
                background: #f1f9ff;
                .el-icon {
                    display: block;
                }
            }
        }

        .history-left::before {
            content: '';
            position: absolute;
            top: 0;
            right: 0px;
            height: 232px;
            width: 1px;
            background-color: #f2f2f2;
        }
        .history-right {
            width: 580px;
            min-width: 580px;
            box-sizing: border-box;
            overflow: hidden;
            padding-left: 10px;
            .history-title {
                justify-content: space-between;
                margin-bottom: 13px;
                .font-size-mini {
                    font-size: 14px;
                    font-weight: 700;
                    color: $font-color-weight-txt;
                }
            }
            .hot {
                display: flex;
                flex-wrap: wrap;
                height: 205px;
                .hot-item {
                    width: 180px;
                    height: 96px;
                    flex-shrink: 0;
                    border-radius: 6px;
                    background: #fff;
                    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.14);
                    margin-right: 10px;
                    display: flex;
                    padding: 10px;
                    box-sizing: border-box;
                    cursor: pointer;
                    img {
                        width: 76px;
                        height: 76px;
                        border-radius: 4px;
                        margin-right: 10px;
                    }
                    .hot-item-right {
                        .name {
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 132%;
                            color: $font-color-weight-txt;
                            margin-bottom: 12px;
                            height: 49px;
                            width: 74px;
                            display: -webkit-box;
                            overflow: hidden;
                            white-space: normal;
                            text-overflow: ellipsis;
                            word-wrap: break-word;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }
                        .price {
                            font-size: 13px;
                            color: $font-color-weight-txt;
                            font-weight: 700;
                            white-space: nowrap;
                        }
                    }
                }
                .hot-item:nth-of-type(3n) {
                    margin-right: 0;
                }
                .hot-item:nth-of-type(1) {
                    margin-bottom: 10px;
                }
            }
        }
    }
    .input-inner {
        position: absolute;
        justify-content: flex-end;
        width: 100%;
        box-sizing: border-box;
        padding: 0 44px 0 20px;
        top: 7px;
        .searchplaceholder {
            color: #ccc;
            font-family: 思源黑体 CN;
            font-size: 14px;
            font-weight: 400;
            line-height: 17px;
            white-space: nowrap;
            margin-right: 40px;
        }
        .hot-goods {
            flex-wrap: wrap;
            overflow: hidden;
            height: 26px;
            justify-content: flex-end;
            .hot-goods-p {
                display: flex;
                padding: 7px 6px;
                justify-content: center;
                align-items: center;
                gap: 10px;
                border-radius: 4px;
                background: #e5f1fc;
                margin-left: 10px;
                cursor: pointer;
                white-space: nowrap;
                color: #004f9a;
                z-index: 6;
            }
        }
    }
}
.searchSelect {
    display: flex;
    padding-left: 20px;
    cursor: pointer;
    z-index: 1;
    position: relative;
    .searchSelect-p {
        color: $font-color-weight-txt;
        font-size: 14px;
        font-weight: 400;
        padding-right: 8px;
        width: 40px;
    }
    .searchSelect-solid {
        width: 1px;
        height: 28px;
        background: #e1e5ee;
        display: inline-block;
        margin-left: 20px;
        margin-top: 3px;
    }
    .searchSelect-down {
        position: absolute;
        width: 104px;
        height: 71px;
        border-radius: 6px;
        background: #fff;
        box-shadow: 0px 1px 4px 0px rgba(6, 22, 36, 0.2);
        top: 50px;
        left: 0px;
        box-sizing: border-box;
        .searchSelect-down-box {
            margin: 6px 0;
            .searchSelect-down-item {
                color: $font-color-weight-txt;
                font-size: 14px;
                font-weight: 400;
                text-align: left;
                padding-left: 20px;
            }
            .is-active {
                color: $font-color;
            }
        }
    }
}
</style>

<style lang="scss">
.search-icon {
    font-size: 20px;
    vertical-align: middle;
    margin-top: 2px;
    margin-left: -2px;
}
.searchinpbox {
    .el-input__wrapper {
        border-radius: 8px !important;
        box-sizing: border-box !important;
        border: 2px solid #0071DC !important;
    }
    .searchinput-active {
        .el-input__wrapper {
            border-radius: 10px 10px 0 0;
        }
    }
    .el-input__inner {
        z-index: 5;
        &::placeholder {
            font-size: 14px;
            color: #BEBEBE;
        }
    }
}
.searchinput {
    box-sizing: border-box;
    height: 40px;
    width: 612px;
    z-index: 5;
    .el-input__wrapper {
        border: none;
        box-sizing: border-box;
        height: 40px;
        border-radius: 20px;
        box-shadow: 0 0 0 2px #fff inset !important;
        padding-left: 16px;
        padding-right: 3px !important;
    }
    .el-input-group__append {
        box-shadow: 0 1px 0 0 #fff inset, 0 -1px 0 0 #fff inset,
            -1px 0 0 0 #fff inset;
        background: #fff;
        color: #fff;
    }
    .search-icon-inp {
        width: 72px;
        height: 40px;
        background: #0071DC;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        color: #fff;
        font-size: 16px;
        z-index: 10;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
    }
}
.search-btn-inp {
    height: 40px;
    box-sizing: border-box;
    width: 42px;
    border: 2px solid #fff !important;
    background: $font-auxiliary-color !important;
    color: #fff !important;
    box-sizing: border-box;
    padding: 0;
    border-radius: 4px;
    img {
        width: 22px;
        height: 22px;
        margin-top: 2px;
        margin-left: 2px;
    }
}
.search-btn-inp:hover {
    width: 42px;
    border: 2px solid #fff !important;
    background: $font-auxiliary-color !important;
}
.inputautocomplete {
    margin-top: 0;
}
.searchinput-el {
    display: none;
}
.test:hover {
    background: red;
}
.fade-in-from-top {
    animation: fade-in 0.5s forwards;
    opacity: 0;
    height: 46px;
    overflow: hidden;
    will-change: opacity, height;
}
@keyframes fade-in {
    0% {
        opacity: 0;
        // height: 0;
    }
    100% {
        opacity: 1;
        // height: 40px;
    }
}
</style>
